jQuery(document).ready(function($) { 

// 	var LARGEUR_MAX_MOBILE = 799;

 	var header = $('#masthead');
 	var l_window = $(window).width();

// 	 /*  ***************************
  //   SCROLL FIXED MENU 
  // ******************************** */
   $(window).scroll(function () {
     // if(l_window > 1023){
        action_on_scroll();
     // }
    });



   function action_on_scroll(){
      l_window = parseInt($(window).width());
       if ($(window).scrollTop() > 50){
          header.addClass("Masthead--sticky");
          $("body").addClass('header--sticky');
        }else{
           header.removeClass("Masthead--sticky");
           $("body").removeClass('header--sticky');
        }
   }



     ////////////////
    //// GLOBAL accordion 
   ///////////////
   $('.accordion-section-content').hide();
   //$('.acc-item.first').addClass('active');
    //$('#content_s_1').parent().find('h2 a').addClass('active');

   //$('.accordion-section-content').hide();
    // accordion SECTION 
    function close_accordion_section() {
        $('.accordion-page .accordion-section-title').removeClass('active');
        $('.accordion-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('aria-controls');

        var parentActiveAcc = $(this).parent().parent().parent().attr('data-accordion-id');

         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).slideUp(300);
         $(parentActiveAcc + ' .acc-item.active .accordion-section-title:not([aria-controls="'+currentAttrValue+'"])').attr('aria-expanded', 'false');
         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $(this).attr('aria-expanded', 'false');
            $('.accordion-page ' + '#'+currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            $(this).attr('aria-expanded', 'true');
            // Open up the hidden content panel
            $('.accordion-page ' + '#'+currentAttrValue).slideDown(300).addClass('open');
            if($('#'+currentAttrValue+'-number').length){
              let to_number = $('#'+currentAttrValue+'-number').attr('data-number');
              let demo = new countUp.CountUp(currentAttrValue+'-number', to_number, options_count);
              demo.start();
            } 
            
        }
 
        e.preventDefault();
    });
    // FIN accordion //
    ////////////////////



     /**** Schema IMPLANTATION zone cliquable ***/
     /***************************************/

    $( ".map_zone_hover" ).click(function() {
      
        var destination_btn_acc = $("#open-zone-"+$(this).attr('id'));
        if(!$(this).hasClass('active_zone')){
            if(l_window < 768){
                 offsetTop = destination_btn_acc.offset().top - 100;
                  $('html, body').stop().animate({ 
                      scrollTop: offsetTop
                  }, 300);
            }
            $('.map_zone_hover').removeClass('active_zone');
            $( this ).addClass('active_zone');
           // $('a.js-action-schema[data-cores="'+$(this).attr('id')+'"]').addClass('active_lb');

            if (destination_btn_acc.length ) { 
                destination_btn_acc.trigger( "click" );
            }
          }
      });

    if(l_window > 767){
        $('.map_zone_hover#isere').trigger( "click" );
    }




  // FORM CONTACT LABEL ///

  $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

  $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });



   $(".menu-toggle").click(function(e){
      if($(this).attr('aria-expanded') == 'true'){
        $('body').addClass('open_menu');
       
      }else{
         $('body').removeClass('open_menu');
      }
   });  

       /* Attention // uniquement si mobile ou tablette ! PODOM */
    $('.BurgerMenu li.menu-item-has-children > a').click(function(e) {
        if($(this).parent().hasClass('focus')){
           $(this).parent().toggleClass('focus');
         }else{
            $('.BurgerMenu li.menu-item-has-children.focus').removeClass('focus');
             $(this).parent().toggleClass('focus');
         }
        
       
        e.preventDefault();
        // charge transition
    });

    $( ".BurgerMenu-L li.current-menu-ancestor" ).each(function( index ) {
      $(this).addClass('focus');
    });



      /***************** PAGE Téléchargement **********************/

     $(document).on("click", ".link_to_scroll", function(e) {
     var item_split = $(this).attr("href");
     var offsetTop = $(item_split).offset().top-20;

      $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 600);
      e.preventDefault();
  });

   $('#offres_emploi').DataTable(
      {
        iDisplayLength:100,
        lengthChange: false,
        // "language": {
        //     "lengthMenu": "Display _MENU_ records per page",
        //     "zeroRecords": "Nothing found - sorry",
        //     "info": "Showing page _PAGE_ of _PAGES_",
        //     "infoEmpty": "No records available",
        //     "infoFiltered": "(filtered from _MAX_ total records)"
        // }
        "language": {
            "lengthMenu": 'Afficher _MENU_ contenu par page',
            "zeroRecords": 'Aucun contenu ne correspond à la recherche - désolé',
            "info": 'Page _PAGE_ de _PAGES_',
            "infoEmpty": 'Rien de trouvé',
            "infoFiltered": ' filtré pour _MAX_ enregistrements',
            "loadingRecords": 'Chargement...',
            "processing":'En attente...',
            "search":'Recherche :',
            "paginate": {
              "first":      'Première',
              "last":       'Dernière',
              "next":       'Suivante',
              "previous":   'Précédente'
          },

        }
     });


     


}); // fin ready menu